import { createRouter, createWebHistory } from 'vue-router'
import { baseUrl } from '@/util/env'
import routes from './routes'

/**
 * 创建并导出 router 实例
 */
const router = createRouter({
  history: createWebHistory(baseUrl),
  routes
})

export default router
